//import { pagination, tableOptions } from '../../..//utils/filters';
import apiHelpers from './apiHelpers.js';
import { mapCrudStoreGen } from '@/helpers/utils/storeHelpers.js';
let defaultForm = {
  ticketNumber: '',
  priority: 2,
  name: '',
  type: 'General Support',
  putIntoBackLog: false
};

let defaultFilters = {
  showOpen: 1,
  search: '',
  status: '',
  priority: -1,
  type: ''
};

let genedStore = mapCrudStoreGen(defaultForm, defaultFilters, apiHelpers);

export default {
  namespaced: true,
  state: () => ({
    ...genedStore.state,
    typeList: [
      { value: 'Bug Report', text: 'Bug Report' },
      { value: 'New Feature', text: 'New Feature Suggestion' },
      { value: 'Feature Improvement', text: 'Feature Improvement' },
      { value: 'General Support', text: 'General Support' },
      { value: 'Reservations', text: 'Reservations' }
    ],
    tableOptions: {
      ...genedStore.state.tableOptions
    },
    pagination: {
      ...genedStore.state.pagination,
      perPage: 25,
      sortBy: 'ModifyDateTimeUtc'
    },
  }),

  mutations: {
    ...genedStore.mutations
  },

  getters: {
    ...genedStore.getters
  },

  actions: {
    ...genedStore.actions
  },
};
